module.exports = __webpack_public_path__ + "media/svg-new/avatar-9 3-21c99399.svg";